(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-testimonials"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-testimonials')) {
    customElements.define(
      'ym-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.ticking = false;

          this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
          window.addEventListener('resize', this.onResize = () => this.update());
          if (this.prev) this.prev.addEventListener('click', () => this.go(this.index() - 1));
          if (this.next) this.next.addEventListener('click', () => this.go(this.index() + 1));
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index() + 1); }
            if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index() - 1); }
          });
          this.update();
        }

        disconnectedCallback() {
          if (this.onResize) window.removeEventListener('resize', this.onResize);
        }

        step() {
          if (this.slides.length < 2) return this.track.clientWidth || 1;
          return this.slides[1].offsetLeft - this.slides[0].offsetLeft || this.track.clientWidth || 1;
        }

        index() {
          const i = Math.round(this.track.scrollLeft / this.step());
          return Math.max(0, Math.min(this.slides.length - 1, i));
        }

        go(i) {
          const target = Math.max(0, Math.min(this.slides.length - 1, i));
          this.track.scrollTo({ left: target * this.step() });
        }

        queueUpdate() {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.update();
          });
        }

        update() {
          const i = this.index();
          this.dots.forEach((dot, n) => {
            if (n === i) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (this.prev) this.prev.disabled = i <= 0;
          if (this.next) this.next.disabled = i >= this.slides.length - 1;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ym-upsell-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ymUpsellCard) return;
    window.__ymUpsellCard = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    /* ---------- 1. Add the upsell together with the main product ----------
       When the shopper presses Add to cart (the main button or the sticky bar, both submit the product
       form) and the upsell card is selected, add the upsell product first, then let the normal add to
       cart run, so the cart drawer opens already showing both products. An upsell that is already in the
       cart is not added a second time. If adding the upsell fails, the main product is still added.

       This listens on window (capture), which runs before the theme's own document-level submit
       handler, so the theme's add to cart only runs once, after the upsell is in the cart. */
    function addUpsell(variantId) {
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (item) { return item.variant_id === variantId; });
          if (inCart) return;
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .catch(function () {});
    }

    window.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        if (form.dataset.ymUpsellPass === '1') {
          delete form.dataset.ymUpsellPass;
          return;
        }

        var component = form.closest('product-form-component');
        if (!component) return;

        var scope = component.closest('.shopify-section') || document;
        var input = scope.querySelector('[data-ym-upsell-input]:checked');
        if (!input) return;

        var variantId = Number(input.getAttribute('data-variant-id'));
        if (!variantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var submitter = event.submitter;
        addUpsell(variantId).then(function () {
          form.dataset.ymUpsellPass = '1';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter && form.contains(submitter) ? submitter : undefined);
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
      },
      true
    );

    /* ---------- 2. Real prices with automatic discounts ----------
       Asks the store's cart (Storefront API, nothing is added to the shopper's real cart) what the main
       product costs on its own and what the pair costs together, so a "buy X get Y free" discount shows
       as $0.00 on the card and the Total row shows the real combined price. */
    var API_URL = '/api/2025-07/graphql.json';
    var QUERY =
      'mutation($lines:[CartLineInput!]!){cartCreate(input:{lines:$lines}){cart{lines(first:10){nodes{' +
      'merchandise{... on ProductVariant{id}} quantity ' +
      'cost{amountPerQuantity{amount} compareAtAmountPerQuantity{amount} totalAmount{amount currencyCode}}}}} ' +
      'userErrors{message}}}';

    function money(amount, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return (currency || '') + ' ' + amount.toFixed(2);
      }
    }

    function lookup(lines) {
      return fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query: QUERY, variables: { lines: lines } })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
          return (cart && cart.lines && cart.lines.nodes) || [];
        });
    }

    function summarize(nodes) {
      var out = { total: 0, compare: 0, currency: null, byId: {} };
      nodes.forEach(function (n) {
        var qty = n.quantity || 1;
        var line = Number(n.cost.totalAmount.amount);
        var per = Number(n.cost.amountPerQuantity.amount);
        var cmp = n.cost.compareAtAmountPerQuantity ? Number(n.cost.compareAtAmountPerQuantity.amount) : 0;
        out.total += line;
        out.compare += Math.max(cmp, per) * qty;
        out.currency = n.cost.totalAmount.currencyCode;
        if (n.merchandise && n.merchandise.id) out.byId[n.merchandise.id] = { total: line, qty: qty };
      });
      return out;
    }

    function remember(card) {
      if (card.__ymOrig) return card.__ymOrig;
      var price = card.querySelector('[data-ym-up-price]');
      var was = card.querySelector('[data-ym-up-was]');
      var save = card.querySelector('[data-ym-up-save]');
      var hint = card.querySelector('[data-ym-up-hint]');
      card.__ymOrig = {
        price: price && price.textContent,
        was: was && was.textContent, wasHidden: was && was.hidden,
        save: save && save.textContent, saveHidden: save && save.hidden,
        hint: hint && hint.textContent
      };
      return card.__ymOrig;
    }

    /* The card's own price: what the upsell costs next to the main product. */
    function applyDeal(card, deal, currency) {
      var orig = remember(card);
      var price = card.querySelector('[data-ym-up-price]');
      var was = card.querySelector('[data-ym-up-was]');
      var save = card.querySelector('[data-ym-up-save]');
      var hint = card.querySelector('[data-ym-up-hint]');
      var regular = Number(card.getAttribute('data-up-price')) / 100;
      var compare = Number(card.getAttribute('data-up-compare')) / 100;

      if (deal === null || !(deal < regular - 0.004)) {
        card.classList.remove('ym-upsell--free');
        if (price) price.textContent = orig.price;
        if (was) { was.textContent = orig.was; was.hidden = orig.wasHidden; }
        if (save) { save.textContent = orig.save; save.hidden = orig.saveHidden; }
        if (hint) hint.textContent = orig.hint;
        return;
      }

      var base = compare > regular ? compare : regular;
      var free = deal < 0.005;
      card.classList.toggle('ym-upsell--free', free);
      if (price) price.textContent = money(deal, currency);
      if (was) { was.textContent = money(base, currency); was.hidden = false; }
      if (save) {
        save.textContent = free ? 'Free with this order' : 'Save ' + Math.round(((base - deal) / base) * 100) + '%';
        save.hidden = false;
      }
      if (hint) hint.textContent = free ? 'Tap to add it free to this order' : orig.hint;
    }

    /* The Total row: main product alone, or main + upsell when the card is selected. */
    function renderTotal(card) {
      var data = card.__ymData;
      if (!data) return;
      var input = card.querySelector('[data-ym-upsell-input]');
      var selected = !!(input && input.checked);
      var s = selected ? data.b : data.a;
      if (!s || !s.currency) return;

      var label = card.querySelector('[data-ym-total-label]');
      var price = card.querySelector('[data-ym-total-price]');
      var was = card.querySelector('[data-ym-total-was]');
      var save = card.querySelector('[data-ym-total-save]');

      if (label) label.textContent = selected ? 'Total with add-on' : 'Total';
      if (price) price.textContent = money(s.total, s.currency);

      var hasSaving = s.compare > s.total + 0.004;
      if (was) { was.textContent = hasSaving ? money(s.compare, s.currency) : ''; was.hidden = !hasSaving; }
      if (save) {
        save.textContent = hasSaving ? 'Save ' + Math.round(((s.compare - s.total) / s.compare) * 100) + '%' : '';
        save.hidden = !hasSaving;
      }
    }

    function refreshDeal(card) {
      var scope = card.closest('.shopify-section') || document;
      var form = scope.querySelector('product-form-component form');
      if (!form) return;

      var data;
      try { data = new FormData(form); } catch (e) { return; }
      var mainId = Number(data.get('id'));
      var qty = Math.max(1, Number(data.get('quantity')) || 1);
      var upId = Number(card.getAttribute('data-up-variant'));
      if (!mainId || !upId || mainId === upId) return;

      var key = mainId + 'x' + qty;
      if (card.__ymKey === key) { renderTotal(card); return; }
      card.__ymKey = key;

      var mainLine = { merchandiseId: 'gid://shopify/ProductVariant/' + mainId, quantity: qty };
      var upLine = { merchandiseId: 'gid://shopify/ProductVariant/' + upId, quantity: 1 };

      Promise.all([lookup([mainLine]), lookup([mainLine, upLine])])
        .then(function (res) {
          if (card.__ymKey !== key) return;
          var a = summarize(res[0]);
          var b = summarize(res[1]);
          var upRow = b.byId['gid://shopify/ProductVariant/' + upId];
          if (!a.currency || !upRow) { card.__ymData = null; applyDeal(card, null); return; }
          card.__ymData = { a: a, b: b };
          applyDeal(card, upRow.total / (upRow.qty || 1), b.currency);
          renderTotal(card);
        })
        .catch(function () { card.__ymKey = null; });
    }

    function tick() {
      if (document.hidden) return;
      var cards = document.querySelectorAll('[data-ym-upsell][data-up-variant]');
      for (var i = 0; i < cards.length; i++) refreshDeal(cards[i]);
    }

    tick();
    document.addEventListener('DOMContentLoaded', tick);
    document.addEventListener('change', function (event) {
      var t = event.target;
      if (t && t.matches && t.matches('[data-ym-upsell-input]')) {
        var card = t.closest('[data-ym-upsell]');
        if (card) renderTotal(card);
      }
      setTimeout(tick, 150);
    });
    setInterval(tick, 1200);
  })();
  } catch(e) { console.error(e); }
})();

})();
